import { Schema } from "effect";

import { ComputerAutomationRequest, type ComputerAutomationStatus } from "./computerAutomation.ts";

export const DesktopComputerAutomationHostError = Schema.Struct({
  _tag: Schema.String.check(Schema.isTrimmed()).check(Schema.isNonEmpty()),
  message: Schema.String,
  detail: Schema.optional(Schema.Unknown),
});
export type DesktopComputerAutomationHostError = typeof DesktopComputerAutomationHostError.Type;

export const DesktopComputerAutomationExecutionResult = Schema.Union([
  Schema.Struct({
    ok: Schema.Literal(true),
    result: Schema.optional(Schema.Unknown),
  }),
  Schema.Struct({
    ok: Schema.Literal(false),
    error: DesktopComputerAutomationHostError,
  }),
]);
export type DesktopComputerAutomationExecutionResult =
  typeof DesktopComputerAutomationExecutionResult.Type;

export const DesktopComputerAutomationExecuteInput = ComputerAutomationRequest;
export type DesktopComputerAutomationExecuteInput =
  typeof DesktopComputerAutomationExecuteInput.Type;

/**
 * Trusted-renderer bridge into the Electron main-process computer-control
 * broker. Only `execute` can increase authority, and it still requires native
 * user consent in the main process. The two local methods can only inspect or
 * reduce an existing lease.
 */
export interface DesktopComputerAutomationBridge {
  execute: (
    request: DesktopComputerAutomationExecuteInput,
  ) => Promise<DesktopComputerAutomationExecutionResult>;
  getStatus: () => Promise<ComputerAutomationStatus>;
  releaseControl: () => Promise<ComputerAutomationStatus>;
  onStateChange: (listener: (state: ComputerAutomationStatus) => void) => () => void;
}
